import type { TableConfig } from '@innovationdepartment/proxima-ui';
import type { Integration, IntegrationType } from './integrations';

export type SearchableBrandType = {
  name: string;
  id: string;
};

export type AdAccountActiveProps = {
  brandId: string | undefined;
  type: IntegrationType;
};

export enum PlanFilterOptions {
  Trial = 'TRIAL',
  Monthly = 'EVERY_30_DAYS',
  Annual = 'ANNUAL'
}

export enum SpendActivityFilterOptions {
  Spending = 'true',
  'Not Spending' = 'false'
}

export type BrandTab = 'all' | 'favorites';

type TabProps = { label: string; key: BrandTab };

export type BrandListIntegrations = {
  [key in BrandTab]: Integration[];
};

// Row is the table's row type (e.g. Brand), not the list type
export type BrandListProps<Row> = {
  onIncludeLockedBrands: (exclude: boolean) => void;
  includeLockedBrands: boolean;
  brandTableRef: React.RefObject<HTMLDivElement | null>;
  onFilterBrands: (name: string) => void;
  onFilterPlans: (selectedPlans: string[]) => void;
  onFilterSpend: (selectedItems: string[]) => void;
  onCreateBrandClick: () => void;
  clearFilters: () => void;
  hasSelectedFilters: boolean;
  filterStateCounter: number;
  tabs: TabProps[];
  selectedTab: BrandTab;
  brands: Row[];
  favorites: Row[];
  onTabChange: (key: BrandTab) => void;
  onNext?: () => void;
  onPrevious?: () => void;
  loading: boolean;
  config: TableConfig<Row>; // https://github.com/InnovationDepartment/proxima.web.components/blob/main/src/lib/Table/README.md
};
